export default __webpack_public_path__ + "assets/images/DTI-FA-Brain.png";